import React, { Component, createRef } from 'react';
import PropTypes from 'prop-types';
import VerticalExpander from './VerticalExpander';
import './UnlabeledVerticalAutoExpander.css';

class UnlabeledVerticalAutoExpander extends Component {
  constructor(props) {
    super(props);

    const { expanded } = props;
    this.content = createRef();
    // this.checkSize.bind(this);

    this.state = { expanded };
  }

  // componentDidMount() {
  //   this.sizeWatcher = setInterval(() => {
  //     this.checkSize();
  //   }, 200);
  // }

  // componentWillUnmount() {
  //   delete this.sizeWatcher;
  // }

  // checkSize() {
  //   if ('current' in this.content && this.content.current !== null) {
  //     this.setState({ height: this.content.current.clientHeight + 20 });
  //   }
  // }

  render() {
    const {
      state: {
        expanded,
        // height,
      },
      props: { children, transitionSpeed },
    } = this;

    const height = 'auto';

    return (
      <div className="unlabeled-vertical-expander">
        <VerticalExpander
          expanded={expanded}
          height={height}
          transitionSpeed={transitionSpeed}
        >
          <div ref={this.content}>{children}</div>
        </VerticalExpander>
      </div>
    );
  }
}

UnlabeledVerticalAutoExpander.propTypes = {
  transitionSpeed: PropTypes.number,
  children: PropTypes.node.isRequired,
  expanded: PropTypes.bool,
};

UnlabeledVerticalAutoExpander.defaultProps = {
  transitionSpeed: 1,
  expanded: false,
};

export default UnlabeledVerticalAutoExpander;
